export default __webpack_public_path__ + "static/media/checkMark.ed15517d.svg";